<template lang="pug">
div(
    class="yotpo yotpo-shoppers-say"
    :data-product-id="yotpoId"
)
</template>

<script>
import mixin from './mixin'

export default {
    mixins: [mixin],
    props: {
        yotpoId: {
            type: String,
            required: true,
        },
    },
}
</script>

<style lang="stylus">
.yotpo-shoppers-say .single-best-sentence .more-reviews
    display none

@screen lg
    .yotpo-shoppers-say .single-best-sentence .more-reviews
        display block
</style>
